export default {"src":"https://fishbrain.com/_next/static/media/arrow-white.169fb7a2.svg","height":18,"width":59,"blurWidth":0,"blurHeight":0};